const toCamelCase = (str: string) => str.replace(/[_-](\w)/g, (_, c) => c.toUpperCase());

export const renameKeysToCamelCaseInPlace = (
  obj: object | Array<unknown>,
  excludeKeys?: string[],
) => {
  if (Array.isArray(obj)) {
    obj.forEach((item) => renameKeysToCamelCaseInPlace(item, excludeKeys));
  } else if (obj !== null && typeof obj === 'object') {
    const keys = Object.keys(obj);

    for (const key of keys) {
      if (excludeKeys?.includes(key)) {
        continue;
      }

      const newKey = toCamelCase(key);
      if (newKey !== key) {
        obj[newKey] = obj[key];
        delete obj[key];
      }
      renameKeysToCamelCaseInPlace(obj[newKey], excludeKeys);
    }
  }
};
